  
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '@asserts/locales/en/en.json';
import zhCN from '@asserts/locales/zh-CN/zhcn.json';
import zhHK from '@asserts/locales/zh-HK/zhhk.json';
import frCH from '@asserts/locales/fr-CH/frch.json';
import itCH from '@asserts/locales/it-CH/itch.json';
import ja from '@asserts/locales/ja/ja.json';
import ptbr from '@asserts/locales/ptbr/ptbr.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      en,
      "zh-CN": zhCN,
      "zh-HK": zhHK,
      "fr-CH": frCH,
      "it-CH": itCH,
      ja,
      "ptbr": ptbr,
    },
    lng: localStorage.getItem('locale') || 'zh-CN',
    fallbackLng: 'zh-CN',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    // ns: 'common',
    // defaultNS: 'common',
    detection: {
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain', 'querystring'],
      lookupCookie: 'locale',
      lookupLocalStorage: 'locale',
      caches: ['cookie', 'localStorage'],
      cookieMinutes: 60 * 24 * 30,
      htmlTag: document.documentElement,
    },
  });

export default i18n;